export default {
  data() {
    return {
      serialNumber: '',
      ending: '',
      year: 0,
    };
  },
  methods: {
    checkSerialNumber() {
      const app = this;
      app.ending = '';
      app.$store.getters.ax
        .post('/guaranties/api/guaranties/info-from-barcode', {
          serialNumber: app.serialNumber,
        })
        .then((response) => {
          if (response.data.guarantee.ending) {
            app.ending = response.data.guarantee.ending;
            app.year = response.data.guarantee.year === 5 ? '5 лет' : '3 года';
          } else {
            this.$store.dispatch('HandleError', 'Неверный серийный номер');
          }
        })
        .catch((error) => {
          this.$store.dispatch('HandleError', error);
        });
    },
  },
};
